import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AnalyticsRouteTracker } from "@/components/AnalyticsRouteTracker";

const PublicPage = lazy(() => import("@/pages/PublicPage"));
const AdminLoginPage = lazy(() => import("@/pages/AdminLoginPage"));
const AdminPage = lazy(() => import("@/pages/AdminPage"));
const ReportPage = lazy(() => import("@/pages/ReportPage"));

/** Old bookmarks: /admin[/campaign/{cid}]/<section> → /app/<section>. */
const LEGACY = { overview: "brief", posts: "evidence", accounts: "sources", keywords: "admin/workspace", news: "sources", "lab/comments": "evidence/comments", "lab/analysis": "reports/analysis", "lab/ask": "evidence/ask", history: "reports/history", settings: "admin/sources" };
const LegacyAdmin = () => {
  const { pathname, search } = useLocation();
  const rest = pathname.replace(/^\/admin(\/campaign\/[^/]+)?\/?/, "");
  const tab = new URLSearchParams(search).get("tab");
  const legacyTab = { dashboard: "brief", suggestions: "admin", lab: "evidence/comments", accounts: "sources", news: "sources" };
  return <Navigate to={`/app/${LEGACY[rest] || legacyTab[tab] || "brief"}`} replace />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsRouteTracker />
        <Suspense fallback={<main className="poc-shell"><p className="poc-hint">Loading…</p></main>}>
          <Routes>
            <Route path="/" element={<PublicPage />} />
            <Route path="/campaign" element={<PublicPage />} />
            <Route path="/login" element={<AdminLoginPage />} />
            <Route path="/admin/login" element={<Navigate to="/login" replace />} />
            <Route path="/app/report/:rid" element={<ReportPage />} />
            <Route path="/admin/report/:rid" element={<ReportPage />} />
            <Route path="/app/cib" element={<Navigate to={`/app/attribution${window.location.search}`} replace />} />
            <Route path="/app/*" element={<AdminPage />} />
            <Route path="/admin/*" element={<LegacyAdmin />} />
            <Route path="/campaigns/:id" element={<Navigate to="/app" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
